import { PeakDataType, RouterType } from "../../constants/types";
import { PublicPageStyle } from "../../constants/styles";
import PeakTemplate from "../templates/PeakTemplate";
import { useCallback, useEffect, useState } from "react";
import { getPeakData } from "../../api/peak";

const PeakPage = (props: RouterType) => {
  const [data, setData] = useState<PeakDataType[]>([]);

  const getData = useCallback(async () => {
    const peak = await getPeakData();

    setData(peak);
  }, []);

  useEffect(() => {
    getData();
  }, [props.render]);

  return (
    <PublicPageStyle>
      <PeakTemplate data={data} />
    </PublicPageStyle>
  );
};

export default PeakPage;
